import ApiService from '../../services/api.service';
import MedialibraryModel from '../medialibrary/medialibrary-model';
import PersonalinfoModel from '../personalinfo/personalinfo-model';

export default class OwnerModel {
    id: number;
    name: string;
    description: string;
    status: string;
    phone: string;
    email: any;
    address: string;
    image: any;
    imageId: number;
    imageUrl: string;
    personalinfo: any;  
    personalinfoLength: number;  

    constructor(datarow:any) {
        if (datarow.attributes) datarow = {...datarow.attributes, id: datarow.id}
        this.id = datarow.id;
        this.name = datarow.name;
        this.description = datarow.description;
        this.status = datarow.status || 'active';
        this.phone = datarow.phone;
        this.email = datarow.email;
        this.address = datarow.address;
        this.image = datarow.image?.data?.map((d: any) => new MedialibraryModel(d))?.[0];
        this.imageId = this.image?.id;
        this.imageUrl = this.image? ((this.image.url?.startsWith('http')? '' : ApiService.svrUrl) + this.image.url) : '';
        this.personalinfo = datarow.personalinfo?.data?.map((d: any) => new PersonalinfoModel(d));
        this.personalinfoLength = this.personalinfo?.length || 0;

    } 

    public static endPoint: string = 'owners' 
    public static endPointMedia: string = 'api::owner.owner';
    public static endPointFilter = () => {
        const owner = OwnerModel.getOwner();
        return ( '?populate[personalinfo][sort]=id&sort=name&filters[id]=' + owner)
    } 
    public static url: string = '/owner';
    public static caption: string = 'Owner';

    public static defaultValue = () => {
        return {
        id: 0,
        name: '',
        description: '',
        status: 'active',
        phone: '',
        email: null,
        address: '',
        image: null,
        imageId: 0,
        imageUrl: '',
        personalinfo: null,
        personalinfoLength: 0,
  
        }
    }
    
    public static validations = [
        { name: 'name', required: true, minLength: 3 },
        { name: 'description', minLength: 3 },
    ]

    public static columns = [
        { name: 'name', caption: 'Name' },
        { name: 'description', caption: 'Description' },
        { name: 'status', caption: ' ', type: 'state', default: 'active' },
    ]

    public static columnPicklist = [
        { name: 'name', caption: 'Name' },
        { name: 'description', caption: 'Description' },
    ]

    public static optionStatus = [
        { name: 'active', caption: 'Active' },
        { name: 'inactive', caption: 'Inactive' },
    ]
    
    public static setOwner(id: string, caption: string) {
        localStorage.setItem('owner',id);
        localStorage.setItem('ownerCaption',caption);
    }

    public static getOwner() {
        return localStorage.getItem('owner') || '';
    }

    public static getOwnerCaption() {
        return localStorage.getItem('ownerCaption') || '';
    }
}